function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: ",
        "px;\n  max-width: ",
        'px;\n  position: relative;\n  width: 100%;\n\n  &:after {\n    content: "";\n    display: block;\n    padding-top: ',
        "%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import styled from "styled-components";
import { space } from "styled-system";
var StyledWrapper = styled.div.withConfig({
    componentId: "sc-c1f44966-0"
})(_templateObject(), function(param) {
    var $height = param.$height;
    return $height;
}, function(param) {
    var $width = param.$width;
    return $width;
}, function(param) {
    var $width = param.$width, $height = param.$height;
    return $height / $width * 100;
}, space);
var Wrapper = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var width = _param.width, height = _param.height, props = _objectWithoutProperties(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ _jsx(StyledWrapper, _objectSpread({
        ref: ref,
        $width: width,
        $height: height
    }, props));
});
export default Wrapper;
